<template>
  <div>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh">
      <van-empty v-if="questionList.length == 0&&topList.length==0" description="暂无内容" />
      <van-list>
        <div class="border-box" v-if="topList.length !== 0||questionList.length !== 0">
          <!-- 判断是否有回复信息 -->
          <div class="item" v-if="item.data.flag==1&&topList.length !== 0" v-for="(item, ind) in topList" :key="item.data.messageid" > 
            <div class="text">
              <div class="text-msg">
                <div class="avatar-img">
                    <img :src="item.data.headimg" alt="">
                  </div>
                <div class="zcrcalss">
                  <div style=" display: flex;justify-content: space-between;">
                    <div>
                      <span class="user-name">{{item.data.name}}</span>
                      <span class="topping">
                        置顶
                      </span>
                      <div>
                        <span class="createtime">
                          {{item.data.createtime}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="twcontent" style="word-wrap: break-word">
                <div class="question-box flex-between">
                  <div class="content-icon">
                    <img :src="require('@/assets/img/loirfe.png')" alt="问"/>
                  </div>
                  <div class="question-right content-text">{{item.data.message}}
                  </div>
                </div>
                <div class="answer-content">
                  <div class="answer-box " v-for="(arr, ind) in item.data.data" :key="ind">
                    <div class="question-box flex-between">
                      <div class="content-icon">
                        <img :src="require('@/assets/img/loufre.png')" alt="答">
                      </div>
                      <div class="answer-right content-text">{{arr.message}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tongwei">
                  <div class="right-btn" >
                    <el-badge :value="item.data.liveActivityqaAgreecountNum" class="item">
                        <span v-if="item.data.Enter" class="mouse-enter" @click="unSetProblem(item,index)">同问</span>
                        <span v-else @click="setProblem(item,index)">同问</span>
                    </el-badge>
                  </div>
                </div>
              </div>
            </div>
          </div>  
          <div class="item" v-if="item.data.flag==1&&questionList.length !== 0" v-for="(item, index) in questionList" :key="index" >
              <div class="text">
                <div class="text-msg">
                  <div class="avatar-img">
                      <img :src="item.data.headimg" alt="">
                    </div>
                  <div class="zcrcalss">
                    <div style=" display: flex;justify-content: space-between;">
                      <div>
                        <span class="user-name">{{item.data.name}}</span>
                        <div>
                          <span class="createtime">
                            {{item.data.createtime}}
                          </span>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div class="twcontent" style="word-wrap: break-word">
                  <div class="question-box flex-between">
                    <div class="content-icon">
                      <img :src="require('@/assets/img/loirfe.png')" alt="问"/>
                    </div>
                    <div class="question-right content-text">{{item.data.message}}
                    </div>
                  </div>
                  <div class="answer-content">
                    <div class="answer-box " v-for="(arr, ind) in item.data.data" :key="ind">
                      <div class="question-box flex-between">
                        <div class="content-icon">
                          <img :src="require('@/assets/img/loufre.png')" alt="答">
                        </div>
                        <div class="answer-right content-text">{{arr.message}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tongwei">
                    <div class="right-btn" >
                      <el-badge :value="item.data.liveActivityqaAgreecountNum" class="item">
                          <span v-if="item.data.Enter" class="mouse-enter" @click="unSetProblem(item,index)">同问</span>
                          <span v-else @click="setProblem(item,index)">同问</span>
                      </el-badge>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 输入框 -->
    <div class="text-inp-box">
      <van-image
        class="avatar"
        round
        width="36px"
        height="36px"
        fit="cover"
        :src="userinfo.headimgurl||headImgs"
      />
      <div class="text-inp-btn">
        <input
          @keydown.enter="questions"
          @input="getProblem"
          v-model="problem"
          type="text"
          class="text-inp"
          placeholder="请输入问题描述（0/200）"
        />
        <!-- <van-icon class="text-inp-send" name="gem" @click="questions" /> -->
        <img class="text-inp-send" :src="require('@/assets/img/send.png')" alt="发送" @click="questions"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/file";
import NewLive from "@/utils/NewLive";
import { opneLoginPane, liveHasLogin, getWxPay } from "@/utils/app";
import {
    mapState,
    mapMutations
  } from "vuex";
import store from "@/store";
export default {
  data () {
    return {
      headImgs:require('@/assets/img/default-header.png'),
      questionList: [], // 消息
      topList:[], // 置顶信息
      tipsList:[], // 提示
      giftList:[], // 礼物
      loading: false,
      finished: false,
      refreshing: false,
      Enter:1,
      problem:'',
      uuid:'',
      info: {
        origin: 'web',
        nickname:'游客',
        id:'游客'+Math.round(Math.random()*1000),
        headimgurl: require('@/assets/img/default-header.png'),
      },
      sendqaobj:{},
      forbiddenData:[],
      ws:null,
      messageData:{}
    };
  },
  props: {
    userinfo: {
      default: () => {
        return {};
      },
      required: true,
    },
  },
  // beforeDestroy () {
  //     console.log('页面关闭前')
  //     alert('页面关闭前')
  //     console.log(this.$setWs.ws)
  //   if(this.$setWs.ws){
  //     this.$setWs.ws.close()
  //   }
  // },
  computed: {
    ...mapState(["config", "inWX", "giftbtn", "IOS","Android"]),
    getWsMsg() {
      //在核心代码接收到的服务端信息存储到vuex的属性
        return this.$store.state.webSocketMsg
    }
  },
  created () {
    if (JSON.stringify(this.userinfo)!=="{}") {
      this.info = this.userinfo
    }
    this.activityId=this.$route.query.id
    this.tvType=this.$route.query.tvType
    // this.socketOpen('qa',this.$route.query.id,this.info);
    // if (this.$setWs.ws) {
    //       this.$setWs.ws.close();
    //     }
    NewLive.get(this.$api.forbiddenuser+'?activityid='+this.activityId).then(res=>{ // 获取禁言名单
        if(res.data.status===0){
          this.forbiddenData=res.data.data
        }
      }).catch(() => {});
  },
  destroyed () {
    console.log('离开页面qa');
    if(this.$setWs.ws){
      this.$setWs.ws.close()
    }
  },
  watch: {
    userinfo(newData){
      this.info = newData
    },
    getWsMsg(data, val) {
      if (data!=='{}') {
        this.messageData = JSON.parse(data)
        this.questionList=this.messageData.questionList
        this.topList=this.messageData.topList
        this.giftList=this.messageData.giftList
        this.tipsList=this.messageData.tipsList
      }
    }
  },
  methods: {
    socketClose () {
      if(this.$setWs.ws){
        console.log('执行close')
        this.$setWs.ws.close()
      }
    },
    // 请求全部信息
    getDetall(type) {
      var a = {
          seq:this.uuid,
          type:type,
          data:{
            type: "getall",
            liveId: this.activityId,
            pagesize:10,
            offset:0,
          }
        };
      this.$setWs.ws.send(JSON.stringify(a));
    },
    // 建立websocket连接
    // type:网页通知message、活动直播-评论聊天chat、活动直播-互动问答qa、活动直播-图文直播live
    // 来源:手机分享页:wechat; 网页预览:web; 后台运营:admin; App:app;
    // 名称:网页:游客+时间戳; 后台:主持人; app:APP账户昵称; 微信:微信昵称;
    socketOpen (type,websocketId,userinfo) {
      if (JSON.stringify(this.userinfo)!=="{}") {
        var origin=userinfo.origin
        var userName=userinfo.nickname
      } else{
        var origin=this.inWX?'wechat':(this.IOS||this.Android)?'app':'web'
        var userName=this.info.nickname
      }
      var device = 1
      let wsServer=''
      if (process.env.NODE_ENV == 'production') {
        var num = process.env.VUE_APP_SCOKET.indexOf('https://')
        var protocol = process.env.VUE_APP_SCOKET.indexOf('https')!==-1 ? 'wss' : 'ws'
        var str = process.env.VUE_APP_SCOKET.substr(num+8)
        wsServer = `${protocol}://${str}websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      } else {
        wsServer = `${location.protocol === 'http:' ? 'ws' : 'wss'}://${location.host}/websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      }
      this.$setWs.initWebSocket(wsServer) // 调用全局定义socket,传入链接
      setTimeout(() => {
        axios.get(this.$api.getUuidSer).then(({ data }) => {
              if (data.status == 0) {
                this.uuid = data.data;
                this.getDetall(type)
              }
            })
      }, 500);
    },
    handleClickRecommendItem (item) {
      this.$emit('handleClickItem', item)
    },
    onLoad () {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        for (let i = 0; i < 10; i++) {
          let item = {
            title: '关于元旦活动问题关于元旦活动问题',
            time: '2021-10-15 12:00:00',
            img: 'https://t7.baidu.com/it/u=852388090,130270862&fm=193&f=GIF'
          }
          this.list.push(item);
        }
        this.loading = false;

        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh () {
      this.refreshing = true
      setTimeout(() => {
        this.$toast('刷新成功!')
        this.refreshing = false;
      }, 1000);
    },
    // 同问
    setProblem (item,index,top) {
      NewLive.get(this.$api.addForbidden+'?activityqaid='+item.data.messageid).then(res=>{
        if(res.data.status==0){
          item.data.Enter = true
          item.data.liveActivityqaAgreecountNum++
          if(top==='top'){
            this.$set(this.topList,index,item)
            this.messageData.topList = this.topList
          } else {
            this.$set(this.questionList,index,item)
            this.messageData.questionList = this.questionList
          }
          
          this.$setWs.messages = this.messageData
          let arr = JSON.stringify(this.messageData)
          store.commit('web_socket_msg', arr)
          console.log(this.$setWs.messages);
          this.$toast.success('操作成功!')
        }
      }).catch(() => {
        this.$toast.error('图文修改异常!')
      });
    },
    // 取消同问
    unSetProblem (item,index,top) {
      NewLive.get(this.$api.minusForbidden+'?activityqaid='+item.data.messageid).then(res=>{
        if(res.data.status==0){
          item.data.Enter = false
          item.data.liveActivityqaAgreecountNum--
          if(top==='top'){
            this.$set(this.topList,index,item)
            this.messageData.topList = this.topList
          } else {
            this.$set(this.questionList,index,item)
            this.messageData.questionList = this.questionList
          }
          this.$setWs.messages = this.messageData
          let arr = JSON.stringify(this.messageData)
          store.commit('web_socket_msg', arr)
          this.$toast.success('操作成功!')
        }
      }).catch(() => {
        this.$toast.error('图文修改异常!')
      });
    },
    // 禁言
    forbiddenWord (itme) {
      console.log(itme);
    },
    // 发表提问
    questions () {
      if(JSON.stringify(this.userinfo)!=='{}'){
      if (this.problem == "") {
        this.$message.error("请输入内容");
      }else if(this.problem.length>200){ 
        this.$toast('最多只能输入200个字!');
        this.problem=this.problem.slice(0,200);
      } else {
        axios.get(this.$api.getUuidSer).then(({ data }) => {
            if (data.status == 0) {
              this.uuid = data.data;
              this.sendqaobj={
              seq:this.uuid,
              type:"qa",
              chatType:this.tvType,
              data:{
                pseq:this.uuid,
                messagetype:'send',
                type:'question',
                userid:this.info.id,
                name:this.info.nickname,
                headimg:this.info.headimgurl,
                showApply:false,
                liveId:this.activityId,//以后会去掉，现在还得传
                message:this.problem,
                word:this.problem,
                flag: 0,
                liveActivityqaAgreecountNum: 0,
                origin: "admin",
                show: "false",
                topflag: 0,
                userforbiddenflag: 0
                }
              }
                let forbidden=false
                this.forbiddenData.forEach(item=>{
                  if (item.userId==this.sendqaobj.data.userid){
                    forbidden = true
                  }
                })
                if (forbidden) {
                  this.$message.warning('您已被禁言!')
                }else{
                  this.$setWs.ws.send(JSON.stringify(this.sendqaobj));
                }
                this.problem = ""
            }
          })
      }
      }else{
          this.$dialog
            .confirm({
              title: "提示",
              message: "该操作需要登录后进行,是否确认登录？",
            })
            .then(() => {
              if (this.inWX) {
                this.$router.replace({name:"login",query: {id:this.$route.query.id,tvType: this.tvType}});
              } else if (this.IOS||this.Android) {
                opneLoginPane()
                window.localStorage.clear();
              }else {
                this.$toast('网页暂不支持此功能!')
              }
            })
            .catch(() => {});
        }
    },
    // 限制弹框
    getProblem () {
      if(this.problem.length>200){
        this.$toast('最多只能输入200个字!');
        this.problem=this.problem.slice(0,200);
      }
    },
  },
}
</script>

<style scoped>
.tongwei >>> .el-badge__content.is-fixed{
  right: 5px;
  top: -2px;
  width: 12px;
  height: 12px;
  padding: 0px;
  line-height: 15px;
  text-align: center;
}
.border-box{
  font-size: 16px;
  /* padding: 0 15px; */
  padding-bottom: 20px;
}
.border-box .text{
  margin-bottom: 10px;
  padding-right: 0px;
  border-bottom: 1px solid #dce2ea;
  padding-bottom: 10px;
}
.text-msg {
  display: flex;
  margin: 10px 0;
  align-items: center;
}

.text-msg > .zcrcalss {
  margin-right: 6px;
  position: relative;
  width: 280px;
}

.text-msg > span {
  color: #8a8a8a;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  /* flex-shrink: 0; */
  margin-right: 6px;
}

.text-msg > p {
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  margin-right: 15px;
  text-align: justify;
}
.topping{
  display: inline-block;
  padding: 2px 6px;
  /* padding:0 5px; */
  background-color:#F0963A;
  cursor: pointer;
  color: rgb(255, 255, 255);
  border-radius: 2px;
  text-align: center;
  margin-left: 10px;
  font-size: 12px;
  text-align: center;
}
.flex-between{
  display: flex;
}
.question-left{
  background: #CEE0FF;
  color: #3378EB;
}
.answer-left{
  background: #FFE2C0;
  color: #FFA43A;
}
.content-icon{
  height: 25px;
  line-height: 25px;
  margin-right: 15px;
}
.content-icon img{
  height: 25px !important;
}
.question-right{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 25px;
}
.answer-right{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 25px;
}
.footer-box{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0px;
  border-top: 2px solid #dfdfdf;
  background-color: #fff;
  z-index: 999;
}
.footer-button{
  width: 1.7rem;
}
.avatar-img{
  width: 34px;
  height: 34px;
  background: transparent;
  border-radius: 15px;
  margin-right: 15px;
  border-radius: 50%;
}
.avatar-img img{
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 50%;
}
.footer-box .avatar-img{
  margin-right: 0px;
}
.tongwei{
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
}
.right-btn img{
  display: block;
  width: 20px;
  height: 20px;
}
.right-btn span{
  display: block;
  font-size: 12px;
  color: #333;
  margin-top: 0px;
}
.right-btn .mouse-enter{
  color: #4D80FF;
}
.user-name{
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.createtime{
  font-size: 10px;
  /* font-weight: 500; */
  color: #999999;
  }
/* .question-box{
  line-height: 32px;
} */
.content-text{
  width: 7rem;
}
.answer-box{
  margin-bottom: 5px;
}
.answer-content{
  margin-top: 5px;
}

.text-inp-box {
  width: 100%;
  height: 56px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0px 25px;
  box-sizing: border-box;
}
.text-inp-btn {
  width: 100%;
  height: 36px;
  position: relative;
  margin-left: 15px;
}
.text-inp {
  width: 100%;
  display: block;
  height: 36px;
  border-radius: 20px;
  border: none;
  background-color: #eff1f6;
  color: #8a8a8a;
  font-size: 14px;
  padding: 0 40px 0 20px;
  box-sizing: border-box;
}
.text-inp-send {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #be1928;
}
</style>